import { useCallback, useRef, useState } from 'react';

import { RowDataTransaction } from 'ag-grid-community';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useSearchParams } from 'react-router-dom';

import { FertilizationQCPanel } from './FertilizationQCPanel';
import { FertilizationDonorScheduleType } from './types';
import { useFertilizationContext } from './useFertilizationContext';

import './Fertilization.css';

export const FertilizationButtons = ({
  className = '',
}: {
  className?: string;
}) => {
  const [params] = useSearchParams();
  const site = params.get('site');
  const date = params.get('date');
  const {
    setShowTodaysFerts,
    handleRefresh,
    donorGridRef,
    handleSelectionChanged,
  } = useFertilizationContext();

  const op = useRef<OverlayPanel>(null);
  const [qcContainer, setQcContainer] = useState<HTMLElement>();

  const handleFillTimeDown = useCallback(() => {
    const visibleNodes = donorGridRef.current?.api.getRenderedNodes();
    let time: string | undefined = undefined;
    visibleNodes?.forEach((element) => {
      if (element.isSelected() === true) {
        const data = { ...element.data };
        if (data.time && data.time !== '' && time === undefined) {
          time = data.time;
        } else {
          data.time = time;
        }
        const tx = {
          update: [data],
        } as RowDataTransaction<FertilizationDonorScheduleType>;
        donorGridRef.current?.api.applyTransaction(tx);
      }
    });
    handleSelectionChanged();
  }, [donorGridRef, handleSelectionChanged]);

  const handleFillCommentsDown = useCallback(() => {
    const visibleNodes = donorGridRef.current?.api.getRenderedNodes();
    let comment: string | undefined = undefined;
    visibleNodes?.forEach((element) => {
      if (element.isSelected() === true) {
        const data = { ...element.data };
        if (
          data.fertComment &&
          data.fertComment !== '' &&
          comment === undefined
        ) {
          comment = data.fertComment;
        } else {
          data.fertComment = comment;
        }
        const tx = {
          update: [data],
        } as RowDataTransaction<FertilizationDonorScheduleType>;
        donorGridRef.current?.api.applyTransaction(tx);
      }
    });
  }, [donorGridRef]);

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <Button icon="pi pi-refresh" onClick={handleRefresh} />

      <Button
        icon="pi pi-eye"
        label="QC Information"
        onClick={(e) => op.current?.toggle(e)}
      />
      <OverlayPanel
        ref={op}
        onShow={() => setQcContainer(op.current?.getElement() ?? undefined)}
      >
        <FertilizationQCPanel container={qcContainer} />
      </OverlayPanel>

      <Button
        className="p-button-secondary"
        icon="pi pi-copy"
        label="Fill Time Down"
        onClick={handleFillTimeDown}
      />
      <Button
        className="p-button-secondary"
        icon="pi pi-copy"
        label="Fill Comments Down"
        onClick={handleFillCommentsDown}
      />

      <Button
        className="p-button-success"
        onClick={() => setShowTodaysFerts(true)}
        disabled={!site || !date}
      >
        Show Todays Ferts
      </Button>
    </div>
  );
};
